import a from '../assets/a.JPG';
import b from '../assets/b.JPG';
import bb from '../assets/bb.JPG';
import bg from '../assets/bg.png';
import logoo from '../assets/logoo.png';



export default {
  a,
  b,
  bb,
  bg,
  logoo,
};
